<button class="scroll-div" (click)="scrolltoTop()">
  top
</button>